<div class="modal-header">
  <h2 mat-dialog-title>
    <ng-container></ng-container>
    <span *ngIf="updating$ | async; else creating">Edit Link</span>
    <ng-template #creating><span trans>New Link</span></ng-template>
  </h2>
  <button type="button" (click)="close()" class="close-button no-style" tabindex="-1">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>

<form (ngSubmit)="data.batch ? shortenBatchUrls() : createOrUpdate()" ngNativeValidate>
  <mat-dialog-content>
    <ng-container *ngIf="linkForm.errors$ | async as errors" [formGroup]="linkForm.formGroup">
      <div *ngIf="data.batch; else single" class="input-container">
        <label for="link-dialog-multiple-urls" trans>Multiple URLs (one per line)</label>
        <textarea
          class="multiple-link-textarea"
          name="link-dialog-multiple-urls"
          id="link-dialog-multiple-urls"
          autocomplete="off"
          spellcheck="false"
          formControlName="long_urls"
          #textarea
        ></textarea>
        <div class="error" *ngIf="errors.long_urls">{{ errors.long_urls }}</div>
      </div>
      <ng-template #single>
        <div class="input-container link-input-container">
          <label for="link-dialog-long-url" class="hidden" trans>Paste long url</label>
          <div class="input-with-action">
            <textarea
              #textarea
              class="single-link-textarea"
              type="text"
              id="link-dialog-long-url"
              autocomplete="off"
              spellcheck="false"
              enterKeybind
              (enterPressed)="createOrUpdate()"
              formControlName="long_url"
              placeholder="Enter long url..."
              trans-placeholder
              [minlength]="minLen"
              [maxlength]="maxLen"
              required
            ></textarea>
            <ng-container *ngIf="settings.get('links.enable_type')">
              <button
                mat-flat-button
                class="type-button"
                color="gray"
                type="button"
                [matMenuTriggerFor]="linkTypeMenu.matMenu"
              >
                <span trans>{{ typeViewName() }}</span>
                <mat-icon svgIcon="arrow-drop-down"></mat-icon>
              </button>
              <link-type-menu
                [linkOptions]="linkOptions$ | async"
                #linkTypeMenu
                formControlName="type"
              ></link-type-menu>
            </ng-container>
          </div>
          <div class="error" *ngIf="errors.long_url">{{ errors.long_url }}</div>
        </div>
      </ng-template>
      <div class="actions">
        <button type="button" class="advanced-options-btn" mat-button (click)="toggleOptions()">
          <mat-icon svgIcon="settings"></mat-icon>
          <span trans>Advanced Options</span>
        </button>
      </div>

      <link-options-form
        [featuresToHide]="data.featuresToHide"
        [@bodyExpansion]="optionsVisible$ | async"
        [linkOptions]="linkOptions$ | async"
        [batch]="data.batch"
      ></link-options-form>
    </ng-container>
  </mat-dialog-content>

  <mat-dialog-actions>
    <share-link-btns
      [showCopyBtn]="true"
      class="colored dialog-actions-left"
      [link]="data.link"
      *ngIf="data.link"
    ></share-link-btns>
    <button
      type="submit"
      class="submit-button"
      mat-raised-button
      color="accent"
      [disabled]="loading$ | async"
      trans
    >
      Confirm
    </button>
  </mat-dialog-actions>
</form>
